<template>
  <div
    class="html_valTypeForString"
    ref="html_valTypeForString"
    v-if="datas.objectInfo && datas.objectInfo.length >= 1"
  >
    <div class="main" :class="datas.objectInfo.length === 2 ? 'column3' : ''">
      <div
        class="player_box"
        :style="{
          width: `calc(${
            datas.objectInfo.length === 1 ? '13.88vw' : '6.94vw'
          } * var(--mixtmt_mixvw))`,
        }"
      >
        <template v-if="palyerInfor[0].playerInfos.length === 0">
          <TeamNameLogo
            :countryImg="palyerInfor[0].teamLogo"
            :countryName="palyerInfor[0].teamName"
            :countryLogoSize="team2CountryLogoSize"
            :cssDynamicObj="cssDynamicObj"
            :width="'calc(6.94vw * var(--mixtmt_mixvw))'"
          ></TeamNameLogo>
        </template>
        <template
          v-else-if="
            palyerInfor[0].playerInfos && palyerInfor[0].playerInfos.length > 1
          "
        >
          <PlayerNames
            :sportCompetitionType="`${datas.sportType}_${datas.competitionType}`"
            :playerInfos="palyerInfor[0].playerInfos"
            :countryImg="palyerInfor[0].teamLogo"
            :countryName="palyerInfor[0].teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="`calc(${
              datas.objectInfo.length === 1 ? '13.88vw' : '6.94vw'
            } * var(--mixtmt_mixvw))`"
          ></PlayerNames>
        </template>
        <template v-else>
          <AbPlayerImg
            :playerImg="palyerInfor[0].playerInfos[0].profilePicture"
            :playerNum="palyerInfor[0].playerInfos[0].shirtNumber * 1"
            :playerName="`${palyerInfor[0].playerInfos[0].playerName}  ${
              palyerInfor[0].playerInfos[0].position
                ? '(' + palyerInfor[0].playerInfos[0].position + ')'
                : ''
            }`"
            :countryImg="
              palyerInfor[0].teamLogo
                ? palyerInfor[0].teamLogo
                : palyerInfor[0].playerInfos[0].countryLogo
            "
            :countryName="
              palyerInfor[0].teamName
                ? palyerInfor[0].teamName
                : palyerInfor[0].playerInfos[0].countryName
            "
            :countryLogoSize="countryLogoSize"
            :age="
              datas.objectInfo.length === 1 
                ? palyerInfor[0].playerInfos[0].age
                : undefined"
            :clubName="
              datas.objectInfo.length === 1 
                ? palyerInfor[0].playerInfos[0].clubName
                : undefined"
            :height="
              datas.objectInfo.length === 1 
                ? palyerInfor[0].playerInfos[0].height
                : undefined"
            :cssDynamicObj="cssDynamicObj"
            :width="`calc(${
              datas.objectInfo.length === 1 ? '13.88vw' : '6.94vw'
            } * var(--mixtmt_mixvw))`"
          ></AbPlayerImg>
        </template>
      </div>

      <div
        class="mid_box"
        :class="datas.statisticsModels.length > 3 ? 'itemsLenMin3' : ''"
      >
        <span
          class="rowItem"
          :class="datas.objectInfo.length === 1 ? 'row2SingleItem' : ''"
          v-for="(item, itemIndex) in datas.statisticsModels"
          :key="itemIndex"
        >
          <span class="rowItem_bg"></span>
          <!-- <span
            class="rowItem_val left"
            v-text="
              _valFormatHandler(tableData[0][item.statisticalEn], item.suffix)
            "
          ></span> -->
          <span
            class="rowItem_val"
            :class="datas.objectInfo.length === 1 ? 'right' : 'left'"
            v-if="
              tableData[0] &&
              _valFormatHandler(tableData[0][item.statisticalEn])
            "
          >
            <template
              v-if="
                tableData[0][item.statisticalEn].indexOf &&
                tableData[0][item.statisticalEn].indexOf('/') > -1
              "
            >
              <NumberScrolling
                :tarVal="tableData[0][item.statisticalEn].split('/')[0]"
                unit="/"
              ></NumberScrolling>
              <NumberScrolling
                :tarVal="tableData[0][item.statisticalEn].split('/')[1]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
            <template v-else>
              <NumberScrolling
                :tarVal="tableData[0][item.statisticalEn]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
          </span>
          <template v-if="inFilterDataType_select">
            <!-- 主题内指标项切换  -->
            <span
              class="rowItem_title"
              :style="{ fontSize: midBoxFontSizeArr[0] }"
            >
              <IndicatorItemsSelect
                :cssDynamicObj="cssDynamicObj"
                :selectList="
                  JSON.parse(JSON.stringify(inFilterDataType_select))
                "
                :selectId="item.id + ''"
                :indexNo="itemIndex"
                @changeValEvent="changeValEventHandler"
              ></IndicatorItemsSelect>
            </span>
          </template>
          <template v-else>
            <span
              class="rowItem_title"
              :style="{ fontSize: midBoxFontSizeArr[0] }"
              v-text="_valFormatHandler(item.name)"
            ></span>
          </template>
          <!-- <span
            class="rowItem_val right"
            v-text="
              _valFormatHandler(tableData[1][item.statisticalEn], item.suffix)
            "
          ></span> -->
          <span
            class="rowItem_val right"
            v-if="
              tableData[1] &&
              _valFormatHandler(tableData[1][item.statisticalEn])
            "
          >
            <template
              v-if="
                tableData[1][item.statisticalEn].indexOf &&
                tableData[1][item.statisticalEn].indexOf('/') > -1
              "
            >
              <NumberScrolling
                :tarVal="tableData[1][item.statisticalEn].split('/')[0]"
                unit="/"
              ></NumberScrolling>
              <NumberScrolling
                :tarVal="tableData[1][item.statisticalEn].split('/')[1]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
            <template v-else>
              <NumberScrolling
                :tarVal="tableData[1][item.statisticalEn]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
          </span>
        </span>
      </div>

      <template v-if="datas.objectInfo.length == 2">
        <div
          class="player_box"
          :style="{ width: `calc(6.94vw * var(--mixtmt_mixvw))` }"
        >
          <template v-if="palyerInfor[1].playerInfos.length === 0">
            <TeamNameLogo
              :countryImg="palyerInfor[1].teamLogo"
              :countryName="palyerInfor[1].teamName"
              :countryLogoSize="team2CountryLogoSize"
              :cssDynamicObj="cssDynamicObj"
              :width="'calc(6.94vw * var(--mixtmt_mixvw))'"
            ></TeamNameLogo>
          </template>
          <template
            v-else-if="
              palyerInfor[1].playerInfos &&
              palyerInfor[1].playerInfos.length > 1
            "
          >
            <PlayerNames
              :sportCompetitionType="`${datas.sportType}_${datas.competitionType}`"
              :playerInfos="palyerInfor[1].playerInfos"
              :countryImg="palyerInfor[1].teamLogo"
              :countryName="palyerInfor[1].teamName"
              :cssDynamicObj="cssDynamicObj"
              :width="'calc(6.94vw * var(--mixtmt_mixvw))'"
            ></PlayerNames>
          </template>
          <template v-else>
            <AbPlayerImg
              :playerImg="palyerInfor[1].playerInfos[0].profilePicture"
              :playerNum="palyerInfor[1].playerInfos[0].shirtNumber * 1"
              :playerName="`${palyerInfor[1].playerInfos[0].playerName}  ${
                palyerInfor[1].playerInfos[0].position
                  ? '(' + palyerInfor[1].playerInfos[0].position + ')'
                  : ''
              }`"
              :countryImg="
                palyerInfor[1].teamLogo
                  ? palyerInfor[1].teamLogo
                  : palyerInfor[1].playerInfos[0].countryLogo
              "
              :countryName="
                palyerInfor[1].teamName
                  ? palyerInfor[1].teamName
                  : palyerInfor[1].playerInfos[0].countryName
              "
              :countryLogoSize="countryLogoSize"
              :cssDynamicObj="cssDynamicObj"
              :width="'calc(6.94vw * var(--mixtmt_mixvw))'"
            ></AbPlayerImg>
            <!-- :width="'6.94vw'"-->
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 运动员数据对比 - val为直接展示的 string 【跳水： 单人 || 双人】
// cba 球队数据
import AbPlayerImg from '../components/PlayerImg'
import PlayerNames from '../components/PlayerNames'
import TeamNameLogo from '../components/TeamNameLogo'
import NumberScrolling from '../components/NumberScrolling'
import IndicatorItemsSelect from '../components/IndicatorItemsSelect'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_valTypeForString',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
    PlayerNames,
    TeamNameLogo,
    NumberScrolling,
    IndicatorItemsSelect,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    inFilter: {
      type: Object,
      default: () => ({
        filterId: 0,
        filterTypes: [],
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {
      // statisticsModels_local: null,
      inFilterDataType: null,
      inFilterDataType_select: null,
    }
  },
  watch: {
    inFilter: {
      handler(newValue, oldValue) {
        console.debug('inFilter:', newValue, oldValue)
        if (newValue) {
          this.initInFilteOpt(newValue)
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    // 模拟数据
    console.debug(this.datas, this.inFilter)
    this.initInFilteOpt(this.inFilter)
    this.$nextTick(() => {
      // 设置CSS变量--main-bg-color的值为'#f0f0f0'
      document.body.style.setProperty(
        '--mixtmt_indicatorItemSelect_mixvw',
        this.cssDynamicObj.mixvw
      )
    })
  },
  // updated() {
  //   console.debug(`更新： ${this.datas}`)
  // },
  computed: {
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList
        : []
    },
    palyerInfor() {
      return this.datas.objectInfo && this.datas.objectInfo.length > 0
        ? this.datas.objectInfo
        : []
    },
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return [
          'calc(1.666vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['1.666vw', '1.666vw']
      } else {
        return [
          'calc(2.498vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['2.498vw', '1.666vw']
      }
    },
    team2CountryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return [
          'calc(5vw * var(--mixtmt_mixvw))',
          'calc(5vw * var(--mixtmt_mixvw))',
        ] //['5vw', '5vw']
      } else {
        return [
          'calc(4.5vw * var(--mixtmt_mixvw))',
          'calc(3vw * var(--mixtmt_mixvw))',
        ] //['4.5vw', '3vw']
      }
    },
    midBoxFontSizeArr() {
      let titleCenter_fontSize = 'calc(0.974vw * var(--mixtmt_mixvw))' //'0.974vw'
      if (
        this.datas &&
        this.datas.statisticsModels &&
        this.datas.statisticsModels.length > 0
      ) {
        this.datas.statisticsModels.forEach((item) => {
          if (item.name && item.name.length > 7) {
            titleCenter_fontSize = 'calc(0.833vw * var(--mixtmt_mixvw))' //'0.833vw'
          }
        })
      }
      return [titleCenter_fontSize]
    },
  },
  methods: {
    initInFilteOpt(inFilter) {
      console.debug('initInFilteOpt', inFilter)
      if (inFilter && inFilter.filterTypes && inFilter.filterTypes[0]) {
        this.inFilterDataType = inFilter.filterTypes[0]
        this.inFilterDataType_select = this.inFilterDataType.values.map(
          (selectItem) => {
            // 不会触及到修改原来的数据
            let newItem = JSON.parse(JSON.stringify(selectItem))
            newItem.value = selectItem.value + ''
            return newItem
          }
        )
      }
    },
    changeValEventHandler(childData) {
      this.$emit('inFilterChangeEvent', {
        data: Object.assign({}, childData, {
          inFilterKey: this.inFilterDataType.name, // 'statisticalIds'
          graphicsId: this.datas.graphicsId,
          analysisItemId: this.datas.analysisItemId,
        }),
      })
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
        }
        data = val + ''
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_valTypeForString {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    position: relative;
    width: 90%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);
    &.column3 {
      width: 94%;
      .mid_box {
        /* width: calc(100% - 2 * 6.94vw); */
        &.itemsLenMin3 {
          .rowItem_title {
            font-size: calc(0.972vw * var(--mixtmt_mixvw));
          }
          .rowItem {
            .rowItem_val {
              padding: 0 calc(0.347vw * var(--mixtmt_mixvw));
              font-size: calc(0.833vw * var(--mixtmt_mixvw));
            }
          }
        }
      }
    }

    .player_box {
      width: calc(6.94vw * var(--mixtmt_mixvw));
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      font-size: calc(0.972vw * var(--mixtmt_mixvw));
    }
    .mid_box {
      /* width: calc(100% - 2 * 6.94vw); */
      flex: 1;
      padding: 0 calc(0.694vw * var(--mixtmt_mixvw));
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      &.itemsLenMin3 {
        height: calc(16.4vw * var(--mixtmt_mixvw));
        overflow: auto;
        .rowItem {
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
          margin-bottom: calc(0.972vw * var(--mixtmt_mixvw));
          .rowItem_bg {
            height: calc(2.083vw * var(--mixtmt_mixvw));
          }
          .rowItem_val {
            padding: 0 calc(0.694vw * var(--mixtmt_mixvw));
            font-size: calc(0.972vw * var(--mixtmt_mixvw));
          }
        }
      }
      .rowItem {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        line-height: calc(2.788vw * var(--mixtmt_mixvw));
        margin-bottom: calc(2.083vw * var(--mixtmt_mixvw));
        &.row2SingleItem {
          .rowItem_title {
            left: 0;
            transform: translateX(0);
            width: 40%;
          }
          .rowItem_val {
            width: 60%;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        .rowItem_bg {
          width: 100%;
          background-color: var(--mixtmt_greyColor7);
          height: calc(2.788vw * var(--mixtmt_mixvw));
          border-radius: calc(1.388vw * var(--mixtmt_mixvw));
        }
        .rowItem_title {
          display: block;
          position: absolute;
          left: 50%;
          top: 0;
          transform: translateX(-50%);
          z-index: 2;
          width: calc(6.94vw * var(--mixtmt_mixvw));
          height: 100%;
          background: linear-gradient(
            90deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          font-size: calc(1.11vw * var(--mixtmt_mixvw));
          font-weight: bold;
          text-align: center;
          border-radius: calc(1.388vw * var(--mixtmt_mixvw));
        }
        .rowItem_val {
          display: block;
          position: absolute;
          top: 0;
          z-index: 2;
          width: calc(50% - 3.74vw * var(--mixtmt_mixvw));
          padding: 0 calc(1.388vw * var(--mixtmt_mixvw));
          color: var(--mixtmt_greyColor3);
          font-size: calc(1.11vw * var(--mixtmt_mixvw));
          font-weight: bold;
          &.left {
            left: 0;
            text-align: left;
          }
          &.right {
            right: 0;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
